export enum TicketCategory {
  TECHNICAL_SUPPORT = 'TECHNICAL_SUPPORT',
  FINANCIAL = 'FINANCIAL',
  GENERAL_INQUIRY = 'GENERAL_INQUIRY',
  BUG_REPORT = 'BUG_REPORT',
  FEATURE_REQUEST = 'FEATURE_REQUEST'
}

export enum TicketStatus {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  CLOSED = 'CLOSED'
}

export enum TicketPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT'
}

export interface Ticket {
  _id: string;
  ticketNumber: string;
  subject: string;
  description: string;
  category: TicketCategory;
  status: TicketStatus;
  priority: TicketPriority;
  userId: {
    _id: string;
    name: string;
    email: string;
  };
  assignedTo?: {
    _id: string;
    name: string;
    email: string;
  };
  assignedAt?: string;
  lastResponseAt?: string;
  canBeAssigned?: boolean;
  attachments: Array<{
    fileName: string;
    originalName: string;
    size: number;
    mimeType: string;
    data?: string; // base64
  }>;
  responses?: Array<{
    _id: string;
    message: string;
    author: {
      _id: string;
      name: string;
      email: string;
      role: string;
    };
    createdAt: string;
  }>;
  // SLA fields
  responseDueAt?: string; // ISO date when first response SLA is due
  resolutionDueAt?: string; // ISO date when resolution SLA is due
  escalated?: boolean;
  escalationLevel?: number;
  responseTime?: number; // ms used for metrics
  resolutionTime?: number; // ms used for metrics
  createdAt: string;
  updatedAt: string;
}

export interface TicketListResponse {
  success: boolean;
  data: {
    tickets: Ticket[];
    totalCount: number;
    currentPage: number;
    totalPages: number;
  };
}

export interface TicketFilters {
  status?: TicketStatus;
  category?: TicketCategory;
  priority?: TicketPriority;
  assignedTo?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface DashboardStats {
  unassignedTickets: number;
  myTickets: number;
  urgentTickets: number;
  totalTickets: number;
  todayTickets: number;
  resolvedThisWeek: number;
} 